import { useEffect, useState } from "react";
import { DataGrid, Loading } from "../../components";
import { PermisoesHelper } from "../../helpers";
import { ListLayout } from "../../layouts";
import { EnderecosEstoqueService, notification } from "../../services";
import { responseErros } from "../../utils";
import AddEnderecosEstoqueDialog from "./components/add-endereco-estoque.dialog";

const ListEnderecosEstoqueView = () => {
  const [id, setId] = useState(false);
  const [enderecoEstoque, setEnderecoEstoque] = useState({});
  const [enderecosEstoque, setEnderecosEstoque] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const permissoesHelper = new PermisoesHelper();
  const enderecosEstoqueService = new EnderecosEstoqueService();

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "endereco",
      headerName: "Endereço de Estoque",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaEnderecosEstoque();
  }, []);

  const buscaEnderecosEstoque = async function (filter) {
    setLoading(true);
    const result = await enderecosEstoqueService.getAll(filter);
    if (!result.isAxiosError) {
      setEnderecosEstoque(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setId(id);
    if (id) {
      const endereco = enderecosEstoque.find((item) => item.id === id);
      setEnderecoEstoque(endereco);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setEnderecoEstoque(null);
    setOpenDialog(false);
  };

  const sendServerDatagrid = (props) => {
    buscaEnderecosEstoque(props.filtros);
  };

  const onClickDeleteRota = async function (id) {
    const enderecoEstoque = enderecosEstoque.find((item) => item.id === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir a rota ${enderecoEstoque.descricao}?`,
    );
    if (retornoAlerta.isConfirmed) {
      setLoading(true);
      const result = await enderecosEstoqueService.deletar(id);
      if (!result.isAxiosError) {
        buscaEnderecosEstoque();
        notification.deletadoSucesso();
      } else {
        responseErros(result);
      }
      setLoading(false);
    }
  };

  return (
    <ListLayout
      title="Endereços de Estoque"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("produtos-cadastrar")}
    >
      <DataGrid
        rows={enderecosEstoque}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={onClickDeleteRota}
        visualizarShow={permissoesHelper.temPermisao("produtos-visualizar")}
        editShow={permissoesHelper.temPermisao("produtos-editar")}
        deleteShow={permissoesHelper.temPermisao("produtos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <AddEnderecosEstoqueDialog
        id={id}
        enderecoEstoque={enderecoEstoque}
        setEnderecoEstoque={setEnderecoEstoque}
        handleCloseDialog={handleCloseDialog}
        buscaEnderecosEstoque={buscaEnderecosEstoque}
        openDialog={openDialog}
        setLoading={setLoading}
      />
      <Loading loading={loading} />
    </ListLayout>
  );
};

export default ListEnderecosEstoqueView;
